import React from 'react'
import { Video } from 'lucide-react'
import { getPortfolioEmbed } from '../utils/portfolioEmbed'

// Toont één portfolio-item zonder het bedrijf van het platform af te leiden.
//
// Bij een YouTube-embed rendert YouTube zelf een titelbalk bovenin de speler;
// die titel is een link naar youtube.com en valt niet met parameters uit te
// zetten (modestbranding/showinfo doen dat allang niet meer). Daarom ligt er
// een transparante strook over de bovenkant die de klik opvangt. Afspelen,
// pauzeren en de bediening onderin blijven gewoon werken.
//
// Volledig dichttimmeren kan een YouTube-embed niet: wie in de speler blijft
// zoeken vindt altijd een route naar youtube.com. Wil je dat echt uitsluiten,
// dan moet YouTube net als Instagram/TikTok als 'blocked' behandeld worden —
// dan vervalt het afspelen.
const PortfolioVideo = ({ item, className = '', objectFit = 'cover' }) => {
  const embed = getPortfolioEmbed(item)

  if (embed.kind === 'file') {
    return (
      <video
        src={embed.src}
        poster={embed.poster || undefined}
        controls
        playsInline
        preload="none"
        className={`w-full h-full object-${objectFit} bg-black ${className}`}
      />
    )
  }

  if (embed.kind === 'youtube') {
    return (
      <div className="relative w-full h-full">
        <iframe
          src={embed.src}
          title={item?.title || 'Portfolio video'}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        />
        {/* Vangt de klik op YouTube's titelbalk op. Hoog genoeg om de titel te
            dekken, laag genoeg om de bediening onderin vrij te laten. Op mobiel
            lager (spelers zijn daar <200px hoog; 56px dekte ~30% van de video). */}
        <div
          className="absolute top-0 left-0 right-0 h-10 sm:h-14 cursor-default"
          onClick={(e) => { e.preventDefault(); e.stopPropagation() }}
          aria-hidden="true"
        />
      </div>
    )
  }

  if (embed.poster) {
    return (
      <img
        src={embed.poster}
        alt={item?.title || 'Portfolio item'}
        loading="lazy"
        className={`w-full h-full object-cover ${className}`}
      />
    )
  }

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-2 text-gray-400 p-4 text-center">
      <Video className="w-8 h-8" />
      <span className="text-xs leading-tight">Video alleen zichtbaar via UGC4you</span>
    </div>
  )
}

export default PortfolioVideo
